<div class="site-page-header-ghost-wrapper">
  <nz-page-header [ngClass]="{ 'scrolled-header': isScrolled }">
    <nz-page-header-title class="header-left">
      <button
        *ngIf="!isHamburgerVisible"
        type="button"
        nz-button
        [nzType]="'text'"
        class="hamburger-button"
        (click)="toggleSidebar($event)"
        (keydown.enter)="toggleSidebar($event)"
        tabindex="0">
        <svg-icon src="/assets/icon/icon-hamburger.svg" class="icon s-12">
        </svg-icon>
      </button>
      <h1 class="header-title">{{ title$ | async }}</h1>
    </nz-page-header-title>

    <nz-page-header-extra>
      <ng-container *ngIf="showOrganizationSearch">
        <app-organization-search
          class="org-search"
          [isNullable]="!isManageSettignRoute"
          [defaultSelectedOrg]="selectedOrg"
          (orgChange)="orgChange($event)">
        </app-organization-search>
      </ng-container>
      <!-- Desktop View -->
      <ng-container *ngIf="!isMobile">
        <div class="cta-wrapper" *ngIf="isOrgRoute$ | async">
          <button
            type="button"
            nz-button
            [nzType]="'default'"
            class="btn"
            (click)="openImportDrawer()">
            Import Data
          </button>
          <button
            nz-button
            nzType="primary"
            (click)="openNewOrganizationDrawer()">
            New Organization
          </button>
        </div>

        <div class="cta-wrapper" *ngIf="isInsightAdminRoute$ | async">
          <button
            nz-button
            *ngIf="activeTab === tabName.BIP"
            nzType="primary"
            (click)="openNewBipCaseDrawer()">
            New BIP Case
          </button>
          <button
            *ngIf="activeTab === tabName.PRE_BIP"
            nz-button
            nzType="primary"
            (click)="openNewPreBipCaseDrawer()">
            New Incident Tracker
          </button>
        </div>

        <div class="cta-wrapper" *ngIf="isUserManageRoute$ | async">
          <ng-container>
            <app-organization-search
              [defaultSelectedOrg]="selectedOrg"
              (orgChange)="orgChange($event)">
            </app-organization-search>
          </ng-container>
          <button
            type="button"
            nz-button
            [nzType]="'default'"
            class="btn"
            [style.marginTop.px]="10"
            (click)="openAddUserComponentDrawer()">
            Add User
          </button>
        </div>
        <div class="cta-wrapper" *ngIf="isDashboardRoute$ | async">
          <div>
            <nz-range-picker
              [(ngModel)]="dateRange"
              [nzAllowClear]="false"
              (ngModelChange)="onDateRangeChange($event)"
              [nzFormat]="'MM/dd/yyyy'"
              [nzDisabledDate]="disabledDate">
            </nz-range-picker>

            <div
              *ngIf="dateRangeError"
              class="error-message"
              style="color: red; margin-top: 5px">
              {{ dateRangeError }}
            </div>
          </div>
        </div>

        <div class="cta-wrapper" *ngIf="isBipTemplateRoute$ | async">
          <button
            type="button"
            nz-button
            [nzType]="'default'"
            (click)="openTemplateLogsDrawer()">
            Template Logs
          </button>
          <button
            type="button"
            nz-button
            [nzType]="'primary'"
            (click)="openAddTemplateDrawer()">
            <span class="text s-14">Add New Template</span>
          </button>
        </div>

        <div class="cta-wrapper" *ngIf="isNewStrategyRoute$ | async">
          <button
            type="button"
            nz-button
            nzType="primary"
            (click)="openNewStrategyDrawer()">
            New Strategy
          </button>
          <button
            nz-button
            [nzType]="'default'"
            (click)="exportStrategyData()"
            [nzLoading]="isExporting$ | async"
            [disabled]="isExporting$ | async">
            Export
          </button>
        </div>
        <ng-container>
          <div class="cta-wrapper" *ngIf="isNotificationRoute$ | async">
            <app-organization-search
              *ngIf="!userData?.isSuperAdmin"
              [defaultSelectedOrg]="selectedOrganizationId"
              (orgChange)="orgChange($event)">
            </app-organization-search>
            <div *ngIf="isNotificationRoute$ | async">
              <button
                *ngIf="
                  userData?.isSuperAdmin ||
                  (selectedOrganizationId && selectedOrganizationId !== 0)
                "
                type="button"
                nz-button
                [title]="'Notification Settings'"
                (click)="openNotificationsSettingsDrawer()"
                nzType="default">
                <svg-icon
                  src="/assets/icon/setting-icon.svg"
                  class="icon s-12 cursor-pointer">
                </svg-icon>
              </button>
            </div>
          </div>
        </ng-container>

        <ng-container>
          <div class="cta-wrapper" *ngIf="isBroadcastRoute$ | async">
            <app-organization-search
              [defaultSelectedOrg]="selectedOrganizationId"
              (orgChange)="orgChange($event)">
            </app-organization-search>
            <button
              nz-button
              [nzType]="'primary'"
              (click)="openBroadcastDrawer()">
              New Broadcast
            </button>
          </div>
        </ng-container>
      </ng-container>

      <!-- Mobile View -->
      <div
        class="mobile-cta-wrapper"
        *ngIf="isMobile && (showMobileCta$ | async)">
        <button
          nz-button
          nz-dropdown
          [nzDropdownMenu]="menu"
          [nzPlacement]="'bottomRight'"
          nzTrigger="click"
          [nzType]="'text'">
          <svg-icon
            [title]="'More options'"
            src="/assets/icon/icon-more.svg"
            class="icon s-16"></svg-icon>
        </button>

        <nz-dropdown-menu #menu="nzDropdownMenu">
          <ul nz-menu>
            <ng-container *ngIf="isOrgRoute$ | async">
              <li
                nz-menu-item
                (click)="openImportDrawer()"
                (keyup.enter)="openImportDrawer()"
                tabindex="0">
                <span class="text s-14">Import Data</span>
              </li>
              <li
                nz-menu-item
                (click)="openNewOrganizationDrawer()"
                (keyup.enter)="openNewOrganizationDrawer()"
                tabindex="0">
                <span class="text s-14">New Organization</span>
              </li>
            </ng-container>

            <ng-container *ngIf="isInsightAdminRoute$ | async">
              <li
                nz-menu-item
                *ngIf="activeTab === tabName.BIP"
                (click)="openNewBipCaseDrawer()"
                (keyup.enter)="openNewBipCaseDrawer()"
                tabindex="0">
                <span class="text s-14">New BIP Case</span>
              </li>
              <li
                nz-menu-item
                *ngIf="activeTab === tabName.PRE_BIP"
                (click)="openNewPreBipCaseDrawer()"
                (keyup.enter)="openNewPreBipCaseDrawer()"
                tabindex="0">
                <span class="text s-14">Create Incident Tracker</span>
              </li>
            </ng-container>

            <ng-container *ngIf="isUserManageRoute$ | async">
              <li
                nz-menu-item
                (click)="openAddUserComponentDrawer()"
                (keyup.enter)="openAddUserComponentDrawer()"
                tabindex="0">
                <span class="text s-14">Add User</span>
              </li>
            </ng-container>

            <ng-container *ngIf="isBipTemplateRoute$ | async">
              <li
                nz-menu-item
                (click)="openTemplateLogsDrawer()"
                (keyup.enter)="openTemplateLogsDrawer()"
                tabindex="0">
                <span class="text s-14">Template Logs</span>
              </li>
            </ng-container>
            <ng-container *ngIf="isBipTemplateRoute$ | async">
              <li
                nz-menu-item
                (click)="openAddTemplateDrawer()"
                (keyup.enter)="openAddTemplateDrawer()"
                tabindex="0">
                <span class="text s-14">Add New Template</span>
              </li>
            </ng-container>

            <ng-container *ngIf="isNewStrategyRoute$ | async">
              <li
                nz-menu-item
                (click)="openNewStrategyDrawer()"
                (keyup.enter)="openNewStrategyDrawer()"
                tabindex="0">
                <span class="text s-14">New Strategy</span>
              </li>
              <li
                nz-menu-item
                (click)="exportStrategyData()"
                (keyup.enter)="exportStrategyData()"
                [ngClass]="{ 'disabled-item': isExporting$ | async }"
                tabindex="0">
                <span class="text s-14">Export</span>
              </li>
            </ng-container>

            <ng-container
              *ngIf="(isNotificationRoute$ | async) && isPrefSettingsAdmin">
              <li
                nz-menu-item
                (click)="openNotificationsSettingsDrawer()"
                (keyup.enter)="openNotificationsSettingsDrawer()"
                tabindex="0">
                <span class="text s-14">Notification Settings</span>
              </li>
            </ng-container>

            <ng-container *ngIf="isBroadcastRoute$ | async">
              <li
                nz-menu-item
                (click)="openBroadcastDrawer()"
                (keyup.enter)="openBroadcastDrawer()"
                tabindex="0">
                <span class="text s-14">New Broadcast</span>
              </li>
            </ng-container>
          </ul>
        </nz-dropdown-menu>
      </div>
    </nz-page-header-extra>
  </nz-page-header>
</div>

<ng-template #importFooterTpl>
  <div class="display-flex justify-content-between drawer-footer">
    <button nz-button nzType="default">Cancel</button>
    <button nz-button nzType="primary">Import File</button>
  </div>
</ng-template>
<ng-template #drawerTemplateLog>
  <app-drawer-header
    [title]="'Template Logs'"
    subtitle="Template Logs"
    [breadcrumbText]="'BIP Template'"
    (close)="closeTemplateLogDrawer()">
  </app-drawer-header>
</ng-template>
<ng-template #drawerAddTemplate>
  <app-drawer-header
    [title]="'Add BIP Template'"
    subtitle="Add BIP Template"
    [breadcrumbText]="'BIP Template'"
    (close)="closeAddTemplateDrawer()">
  </app-drawer-header>
</ng-template>

<ng-template #drawerNewStrategy>
  <app-drawer-header [title]="'New Strategy'" subtitle="" [breadcrumbText]="''">
  </app-drawer-header>
</ng-template>

<ng-template #drawerAddUser>
  <app-drawer-header [title]="'Add User'"> </app-drawer-header>
</ng-template>
